<template>
  <div>
    <mapbox
      :map-options="mapOptions"
      :geolocate-control="geolocateControl"
      :nav-control="navControl"
      :access-token="mapboxToken"
      @map-init="mapInitialized" />
  </div>
</template>

<script>

import Mapbox from 'mapbox-gl-vue'

export default {
  name: 'ChargingMap',
  components: {
    Mapbox
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      mapboxToken: process.env.VUE_APP_MAPBOX_TOKEN,
      mapOptions: {
        style: this.mapStyle,
        center: [172.8, -41.5],
        zoom: 4
      },
      navControl: {
        show: true,
        position: 'bottom-right'
      },
      geolocateControl: {
        show: true,
        position: 'bottom-right',
        options: {
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true
        }
      },
      icons: [
        {
          'id': 'planned',
          'icon-image': 'future_min',
          'filter': [
            'all',
            [
              '==',
              ['get', 'installationStatus'],
              'Future'
            ]
          ]
        },
        {
          'id': 'construction',
          'icon-image': 'construction_min',
          'filter': [
            'all',
            [
              '==',
              ['get', 'installationStatus'],
              'Under Construction'
            ],
            [
              'any',
              [
                '==',
                ['get', 'atLeastMedium'],
                true
              ],
              [
                '==',
                ['get', 'source'],
                'chargenet'
              ]
            ]
          ]
        },
        {
          'id': 'medium',
          'icon-image': 'medium_min',
          'filter': [
            'all',
            [
              '==',
              ['get', 'installationStatus'],
              'Commissioned'
            ],
            [
              '==',
              ['get', 'medium'],
              true
            ],
            [
              '!=',
              ['get', 'fast'],
              false
            ],
            [
              '!=',
              ['get', 'mixed'],
              true
            ]
          ]
        },
        {
          'id': 'mixed',
          'icon-image': 'mixed_min',
          'filter': [
            'all',
            [
              '==',
              ['get', 'installationStatus'],
              'Commissioned'
            ],
            [
              '==',
              ['get', 'mixed'],
              true
            ]
          ]
        },
        {
          'id': 'fast',
          'icon-image': 'fast_min',
          'filter': [
            'all',
            [
              '==',
              ['get', 'installationStatus'],
              'Commissioned'
            ],
            [
              '==',
              ['get', 'fast'],
              true
            ],
            [
              '!=',
              ['get', 'mixed'],
              true
            ]
          ]
        }
      ],
      text: [
        {
          'id': 'label',
          'text': ['get', 'name'],
          'filter': [
            'any',
            [
              '==',
              ['get', 'atLeastMedium'],
              true
            ],
            [
              '==',
              ['get', 'installationStatus'],
              'Future'
            ]
          ]
        }
      ]
    }
  },
  computed: {
    mapStyle: function () {
      return 'mapbox://styles/arthurmcgregor/cjo6885mf0n652rrpugse967m' // streets basemap v2
    },
    map: function () {
      return this.$store.state.map.map
    }
  },
  mounted: function () {
    // Set initial style
    this.setStyle(this.mapStyle)
    // Update mapLoaded value
    this.map.on('load', () => {
      // mapIsLoaded is a local variable to ensure that the addLayers()
      // method does not run until the map has loaded (as they can be triggered
      // by the watches)
      this.mapIsLoaded = true
      this.$emit('mapLoaded')
      this.addLayers()
    })
  },
  methods: {
    mapInitialized (map) {
      this.$store.commit('map/mapInitialized', map)
    },
    setStyle (style) {
      this.map.setStyle(style)
    },
    addLayers () {
      // Only add layers if both map and data have loaded
      if (this.mapIsLoaded && Object.keys(this.data).length > 0) {
        this.map.addSource('data', {
          type: 'geojson',
          data: this.data
        })
        this.icons.forEach((layer) => {
          this.map.addLayer({
            'id': layer.id,
            'type': 'symbol',
            'source': 'data',
            'layout': {
              'icon-image': layer['icon-image'],
              'icon-allow-overlap': true
            },
            filter: layer.filter
          })
        })
        this.text.forEach((layer) => {
          this.map.addLayer({
            'id': layer.id,
            'type': 'symbol',
            'source': 'data',
            'layout': {
              'text-field': [
                'step',
                [ 'zoom' ],
                '',
                8,
                layer.text,
                22,
                layer.text
              ],
              'text-offset': [ 0, 0.5 ],
              'text-anchor': 'top'
            },
            filter: layer.filter
          })
        })
      }
    }
  }
}

</script>

<style scoped>

</style>
